import React from "react";
import useFetch from "../../hooks/useFetch";

function Blog() {
  const [data, isLoading] = useFetch();
  console.log(data);

  return (
    <div>
      <p className="font-bold my-6 text-black text-2xl text-center">
        <span
          style={{
            backgroundImage:
              "linear-gradient(120deg, #84fab0 0%, #6366f1 100%)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 0.2em",
            backgroundPosition: "0 88%",
            transition: "background-size 0.25s ease-in",
          }}
          className="dark:text-white"
        >
          Latest Posts
        </span>
      </p>
      <div className="container mx-auto my-2">
        {isLoading
          ? "Loading"
          : data?.publication?.posts.map((post) => (
            // w-98 md:w-2/3 mx-2 my-6 md:mx-auto bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700
              <div className="w-98 md:w-2/3 mx-2 my-6 md:mx-auto bg-white rounded-lg border border-gray-200 dark:bg-slate-800 dark:border-gray-500 dark:border shadow-md">
                <a href={`https://abdelmalek.hashnode.dev/${post.slug}`}>
                  <img
                    className="rounded-t-lg h-[250px] md:h-[350px] w-full object-cover"
                    src={post.coverImage}
                    alt=""
                  />
                </a>
                <div className="p-5">
                  <a href={`https://abdelmalek.hashnode.dev/${post.slug}`}>
                    {/* mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white */}
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                      {post.title}
                    </h5>
                  </a>
                  <p className="mb-3 font-normal text-gray-700 dark:text-gray-400 dark:text-slate-400">
                      {post.brief}
                  </p>
                  <a
                    href={`https://abdelmalek.hashnode.dev/${post.slug}`}
                    className="inline-flex items-center py-2 px-3 text-sm font-medium text-center text-dark rounded-lg hover:bg-blue-800 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-700 dark:text-white dark:focus:ring-blue-800"
                  >
                    Read more
                    <svg
                      className="ml-2 -mr-1 w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
}

export default Blog;
